
















































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import dayjs from 'dayjs'
import { InjectReactive, Prop, Watch } from 'vue-property-decorator'
import { LatestNewsCollection, LatestNewsCollectionType } from '@/modules/news/models/news-collection.model'
import { DateHelper } from '@/modules/shared/helpers/date'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'

@Component({
  components: { BaseSelect }
})
export default class NewsForm extends Vue {

  @InjectReactive()
  news!: LatestNewsCollectionType

  @Prop() newsItem!: LatestNewsCollection
  @Prop() needClearForm!: boolean

  private newsTitleLabel: string = 'عنوان خبر'
  private newsLeadLabel: string = 'چکیده مطلب'
  private newsUrlLabel: string = 'آدرس خبر'
  private dateDialog: boolean = false
  private dense: boolean = true

  constructor(
    private readonly dateHelper: DateHelper
  ) {
    super()
  }

  mounted() {
    // this.newsItem.created_at = dayjs(this.newsItem.created_at).format('YYYY/MM/DD')
    // this.newsItem.updated_at = dayjs(this.newsItem.created_at).format('YYYY/MM/DD')
  }

  get newsItemTitle() {
    return this.newsItem.title
  }

  set newsItemTitle(value) {
    this.newsItem.title = value
  }

  get newsItemLead() {
    return this.newsItem.lead
  }

  set newsItemLead(value) {
    this.newsItem.lead = value
  }

  get newsItemImgSrc() {
    return this.newsItem.image_src
  }

  set newsItemImgSrc(value) {
    this.newsItem.image_src = value
  }

  get newsItemUrl() {
    return this.newsItem.url
  }

  set newsItemUrl(value) {
    this.newsItem.url = value
  }

  get newsItemDate() {
    return this.getJalaliDate(this.newsItem.created_at)
  }

  set newsItemDate(value) {
    this.newsItem.created_at = this.jalaliToGregory(value)
  }

  //

  jalaliToGregory(value) {
    return this.dateHelper.fromJalali(value).toTimestamp()
  }

  getJalaliDate(value) {
    return dayjs(value).format('YYYY/MM/DD')
  }

  //clearForm Watcher
  @Watch('needClearForm')
  onFormClear(val: string, oldVal: string) {
    this.clearForm()
  }

  clearForm() {
    this.newsItemTitle = ''
    this.newsItemUrl = ''
    this.newsItemLead = ''
    this.newsItemDate = dayjs(new Date()).format('YYYY/MM/DD')
    this.newsItemImgSrc = ''
  }

}
